import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map,switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { MarketplaceBalanceState } from "../../models/mp-admin/marketplace-balance-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class MarketplaceBalanceEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.marketplaceBalance.get),
			withLatestFrom(this.store.select(MpAdminSelectors.marketplaceBalance)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.marketplaceBalance.getSuccess(state))
					: of(MpAdminActions.marketplaceBalance.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.marketplaceBalance.getApi),
			switchMap(() =>
				this.adminService.marketplaceBalance().pipe(
					map((marketplaceBalance) =>
						MpAdminActions.marketplaceBalance.getSuccess({
							marketplaceBalance,
							loading: false
						})
					),
					catchError((error) =>
						of(MpAdminActions.marketplaceBalance.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private adminService: MpAdminService
	) {}

	private canUseStoreValue(action, state: MarketplaceBalanceState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
